import React from 'react';

const SolutionExp = ({ number, randomPrefTo, randomUnit, expSolution }) => {
    return (
        <td>
            <div className="notation left num">{number}</div>
            <div className="notation right">
                <div className="exponent">&nbsp;· 10 <sup>{expSolution}</sup></div>
                &nbsp;
                <div className="unit">{randomPrefTo.letter}{randomUnit.letter}</div>
            </div>
        </td>
    )
}

export default SolutionExp;
